import { UpdateProposalConfigurationRequestDTO } from '@modules/proposals/api/dto/updateProposalConfiguration.dto';
import { ProposalConfigFormValues } from '../index';

export const mapConfiguratorFormValuesToDTO = ({
  config,
  consultationFee,
}: ProposalConfigFormValues): UpdateProposalConfigurationRequestDTO => ({
  show_bank_logos: config.showBankLogos,
  is_documents_required: config.showRequiredDocuments,
  show_land_department_fee: config.feesToShow.includes('land_department_transfer_fee'),
  show_mortgage_registration_fee: config.feesToShow.includes('mortgage_registration_fee'),
  show_mortgage_release_fee: config.feesToShow.includes('mortgage_release_fee'),
  show_transfer_center_fee: config.feesToShow.includes('transfer_center_fee'),
  show_real_estate_fee: config.feesToShow.includes('real_estate_fee'),
  consultation_fee: consultationFee,
});
